import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo',
  standalone: true
})
export class DateAgoPipe implements PipeTransform {
  transform(value: string | Date, isUtc = true): string {
    if (!value) return '';

    const date = new Date(value);
    const now = new Date();
    const timezoneOffset = isUtc ? date.getTimezoneOffset() : 0;
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000 + timezoneOffset * 60);

    if (seconds < 60) {
      return 'just now';
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (seconds < 604800) {
      const days = Math.floor(seconds / 86400);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleString();
    }
    // } else if (seconds < 2592000) {
    //   // 30 days
    //   const days = Math.floor(seconds / 86400);
    //   return `${days} day${days > 1 ? 's' : ''} ago`;
    // } else if (seconds < 31536000) {
    //   // 365 days
    //   const months = Math.floor(seconds / 2592000);
    //   return `${months} month${months > 1 ? 's' : ''} ago`;
    // } else {
    //   const years = Math.floor(seconds / 31536000);
    //   return `${years} year${years > 1 ? 's' : ''} ago`;
    // }
  }
}
